let modalStack = [];

class ModalComponent extends HTMLElement {
  constructor() {
    super();

    this.modalContent = this.querySelector("[data-modal-content]");
    this.closeButtons = [...this.querySelectorAll("[data-modal-close]")];
    this.body = document.querySelector("body");
    this.header = document.getElementsByTagName("section-header")[0];
    this.init();

    this.closeEsc = (event) => {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      if (modalStack.length && modalStack[modalStack.length - 1] === this) {
        this._close();
      }
    };

    document.addEventListener("keyup", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("keyup", this.closeEsc);
  }

  init() {
    //updated
    const modalId = this.dataset.id;
    this.closeButtons = [...this.querySelectorAll("[data-modal-close]")];
    window.addEventListener("click", (event) => {
      const modalTrigger = event.target.closest('[data-modal-trigger]');
      if (
        modalTrigger &&
        modalTrigger.dataset.modalTrigger == modalId
      ) {
        event.preventDefault();
        this.toggleModal(true);
      }
    });
    this.closeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggleModal(false);
        this.header.style = "";
      });
    });
  }

  //removed code that moves header down and over modal
  toggleModal(open) {
    if (open) {
      this._open();
    } else {
      this._close();
    }
  }

  trapFocus() {
    window.trapFocus(this, this.querySelector("[data-modal-close]"));
  }

  _open() {
    if (this.classList.contains("show-modal")) return;

    this.returnFocusEl = document.activeElement;
    this.style.display = "block";
    modalStack.push(this);

    window.requestAnimationFrame(() => {
      document.documentElement.classList.add("overflow-hidden");
      document.body.classList.add("overflow-hidden");
      this.classList.add("show-modal");
      this.dispatchEvent(new CustomEvent("modal:open"));
      this.trapFocus();
    });
  }

  _close() {
    if (!this.classList.contains("show-modal")) return;

    modalStack = modalStack.filter((modal) => modal !== this);
    window.removeTrapFocus(this.returnFocusEl);
    if (modalStack.length) {
      modalStack[modalStack.length - 1].trapFocus();
    }

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);
      this.style.display = null;
      this.dispatchEvent(new CustomEvent("modal:close"));
    };

    this.addEventListener("transitionend", onEnd);

    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("show-modal");
  }
}

if (!customElements.get("modal-component")) {
  customElements.define("modal-component", ModalComponent);
}
